import cx from 'clsx';
import * as React from 'react';

import * as styles from './styles.css';
import { ErrorButton } from '../../GroupsSection/ErrorButton';
import { MobileLayoutContainer } from '../MobileLayout';
import { TabletAndDesktopLayout } from '../TabletAndDesktopLayout';

interface IPageProps {
  isError?: boolean;
  recallFailed(): void;
}

export const Page: React.FC<IPageProps> = ({ recallFailed, isError }) => {
  return (
    <div>
      <div className={cx(styles['error_container'], isError && styles['error_container--visible'])}>
        <ErrorButton callback={recallFailed}>
          Произошла ошибка.
          <span className={styles['error_button']}>Попробуйте снова</span>
        </ErrorButton>
      </div>
      <MobileLayoutContainer key="MobileLayout" />
      <TabletAndDesktopLayout key="TabletAndDesktopLayout" />
    </div>
  );
};
